import React from 'react'

export interface FormattedTextProps {
  children: string
  boldNumbers?: boolean
}

export const FormattedText = ({
  children,
  boldNumbers = false,
}: FormattedTextProps) => {
  // Helper function to process a text segment for numbers.
  const processForNumbers = (text: string) => {
    // Split by any sequence of digits. The capturing parentheses ensure that the numbers
    // are included in the result array.
    const parts = text.split(/(\d+)/)
    return parts.map((part, idx) => {
      // Check if the part is a number. Note that this regex matches one or more digits.
      if (/^\d+$/.test(part)) {
        return <b key={idx}>{part}</b>
      }
      return part
    })
  }

  // First, split the entire text by the explicit bold markers "**"
  const explicitBoldParts = children.split('**')

  return (
    <>
      {explicitBoldParts.map((part, index) => {
        // For the parts that were wrapped in ** markers (odd indexes), we know they are bold.
        if (index % 2 !== 0) {
          return <b key={index}>{part}</b>
        }

        // For non-bold text, process further if boldNumbers is true.
        if (boldNumbers) {
          return (
            <React.Fragment key={index}>
              {processForNumbers(part)}
            </React.Fragment>
          )
        }

        return <React.Fragment key={index}>{part}</React.Fragment>
      })}
    </>
  )
}
